angular.module('workflow')
    .component('workflowAccessGroupList', {
        bindings: {
            page: '<',
            filters: '<'
        },
        templateUrl: 'app/workflow/access-group/list.html',
        controller: function ($scope, $state, WorkflowAccessGroupService, WorkflowAccessGroupConst) {
            this.reset = () => this.filters = {}
            this.WorkflowAccessGroupService = WorkflowAccessGroupService
            $scope.$on(WorkflowAccessGroupConst.eventUpdate, () => $state.reload())
        }
    })
